import { ISCompetitionTypesEnum } from '@ess/integrated-search/shared/utils';

export const IS_COMPETITION_TYPES_LABELS: { [key in ISCompetitionTypesEnum]: string } = {
  [ISCompetitionTypesEnum.LOW]: 'Low',
  [ISCompetitionTypesEnum.MEDIUM]: 'Medium',
  [ISCompetitionTypesEnum.HIGH]: 'High',
  [ISCompetitionTypesEnum.UNSPECIFIED]: 'Unspecified',
};
